import {forwardRef, HTMLAttributes} from 'react';

const TableStaticRow = forwardRef<
    HTMLTableRowElement,
    HTMLAttributes<HTMLTableRowElement>
>(({children, ...props}, ref) => {
    return (
        <tr ref={ref} {...props}>
            {children}
        </tr>
    );
});

TableStaticRow.displayName = 'TableStaticRow';

export default TableStaticRow;
